<div class="page-view-nav">
  <div style="display: flex" *ngIf="showSidebar">
    <div class="page-view-nav-sidebar" *ngIf="!isHidden">
      <div class="page-view-nav-link-list" role="navigation">
        <ng-container *ngIf="!links.length">
          <div class="page-view-nav-loader-container">
            <span
              ><i class="fas fa-spinner fa-spin fa-spinner-small"></i
            ></span></div
        ></ng-container>
        <ng-container *ngFor="let link of links">
          <a
            *ngIf="!link?.hidden"
            class="page-view-nav-navigation-item background-hover left-menu-button"
            tourTarget
            [tourId]="link.tourId"
            [stepId]="link.stepId"
            [tourPosition]="link.position"
            [routerLink]="link?.directRoute || link.route"
            (click)="tourService.nextStep(link.tourId, link.stepId)"
            [ngClass]="inRoute(link.route) ? 'primary-background-sidenav' : ''"
          >
            <span style="text-transform: capitalize; white-space: normal">{{
              link.translation_key || link.text | translation
            }}</span>
          </a>
        </ng-container>
      </div>
    </div>

    <p-button
      styleClass="menu-toggle"
      [variant]="'text'"
      size="small"
      severity="contrast"
      (click)="isHidden = !isHidden"
    >
      <i
        *ngIf="isHidden"
        style="font-weight: 400; font-size: 12px"
        class="fas fa-chevron-right"
      ></i
      ><i
        *ngIf="!isHidden"
        style="font-weight: 400; font-size: 12px"
        class="fas fa-chevron-left"
      ></i>
    </p-button>
  </div>

  <div class="page-view-nav-content">
    <div class="page-view-nav-breadcrumb-wrapper">
    <div class="page-view-nav-breadcrumb-holder breadcrumb-holder" *ngIf="breadcrumbs?.length">
      <span *ngFor="let link of breadcrumbs; let last = last">
        <a
          *ngIf="!last && !link?.avoidLink; else textview"
          routerLink="{{ link.link }}"
          >{{ link.text }}</a
        >
        <span *ngIf="!last" class="page-view-nav-breadcrumb-seperator">
          <i class="fas fa-chevron-right" style="font-size: 10px"></i>
        </span>
        <ng-template #textview>
          <span>{{ link.text }}</span>
        </ng-template>
      </span>
    </div>
  </div>
    <div class="page-view-nav-child-view-content">
      <ng-content></ng-content>
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Sticky button container -->
  <div class="page-view-nav-sticky-button-container">
    <ng-container *ngIf="stickyButtonContent">
      <div class="page-view-nav-sticky-button">
        <ng-container *ngTemplateOutlet="stickyButtonContent"></ng-container>
      </div>
    </ng-container>
  </div>
</div>
